// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 0Oim0KTDv11d
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import CreateNewStack from "../../CreateNewStack"; // plasmic-import: klpgYFOobDsk/component
import ProfileStack from "../../ProfileStack"; // plasmic-import: 0Avth2hHpq79/component
import CreateNew from "../../CreateNew"; // plasmic-import: Q0aOqKnaVDqy/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicTopBar.module.css"; // plasmic-import: 0Oim0KTDv11d/css
import Icons8Settings1Icon from "./icons/PlasmicIcon__Icons8Settings1"; // plasmic-import: 4myR7kWj9ZI_/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: cdQ-QsSHJP16/icon
import GroupIcon from "./icons/PlasmicIcon__Group"; // plasmic-import: YctzKJSFJvt3/icon

createPlasmicElementProxy;

export const PlasmicTopBar__VariantProps = new Array();

export const PlasmicTopBar__ArgProps = new Array("userNameText");

const $$ = {};

function PlasmicTopBar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"title6"}
        data-plasmic-override={overrides.title6}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.title6
        )}
      >
        {"CollectWise Dashboard"}
      </div>
      <CreateNewStack
        data-plasmic-name={"createNewStack"}
        data-plasmic-override={overrides.createNewStack}
        className={classNames("__wab_instance", sty.createNewStack)}
      />

      <Icons8Settings1Icon
        data-plasmic-name={"settingsButton"}
        data-plasmic-override={overrides.settingsButton}
        className={classNames(projectcss.all, sty.settingsButton)}
        role={"img"}
      />

      <DividerLineVerticalIcon
        className={classNames(projectcss.all, sty.svg___4Qtyp)}
        role={"img"}
      />

      <div
        data-plasmic-name={"name"}
        data-plasmic-override={overrides.name}
        className={classNames(projectcss.all, sty.name)}
      >
        {renderPlasmicSlot({
          defaultContents: "Jones Ferdinand",
          value: args.userNameText,
          className: classNames(sty.slotTargetUserNameText)
        })}
      </div>
      <ProfileStack
        data-plasmic-name={"profileStackInstance"}
        data-plasmic-override={overrides.profileStackInstance}
        className={classNames("__wab_instance", sty.profileStackInstance)}
      />

      {false ? (
        <Stack__
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__cY2Ob)}
        >
          <div
            data-plasmic-name={"title7"}
            data-plasmic-override={overrides.title7}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.title7
            )}
          >
            {"Merchant Dashboard"}
          </div>
          <CreateNew
            className={classNames("__wab_instance", sty.createNew__cPgGu)}
          />

          <Icons8Settings1Icon
            className={classNames(projectcss.all, sty.svg__f5XH)}
            role={"img"}
          />

          <DividerLineVerticalIcon
            className={classNames(projectcss.all, sty.svg__yhciD)}
            role={"img"}
          />

          <div
            data-plasmic-name={"name2"}
            data-plasmic-override={overrides.name2}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.name2
            )}
          >
            {"Jones Ferdinand"}
          </div>
          <GroupIcon
            className={classNames(projectcss.all, sty.svg__vFzmo)}
            role={"img"}
          />
        </Stack__>
      ) : null}
      {false ? (
        <Stack__
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__ikLx8)}
        >
          <div
            data-plasmic-name={"title8"}
            data-plasmic-override={overrides.title8}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.title8
            )}
          >
            {"Merchant Dashboard"}
          </div>
          <CreateNew
            className={classNames("__wab_instance", sty.createNew__qtMql)}
          />

          <Icons8Settings1Icon
            className={classNames(projectcss.all, sty.svg__bRh8J)}
            role={"img"}
          />

          <DividerLineVerticalIcon
            className={classNames(projectcss.all, sty.svg__sWij4)}
            role={"img"}
          />

          <div
            data-plasmic-name={"name3"}
            data-plasmic-override={overrides.name3}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.name3
            )}
          >
            {"Jones Ferdinand"}
          </div>
          <GroupIcon
            className={classNames(projectcss.all, sty.svg__mwnS)}
            role={"img"}
          />

          {false ? (
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__pl3Iy)}
            >
              <div
                data-plasmic-name={"title9"}
                data-plasmic-override={overrides.title9}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title9
                )}
              >
                {"Merchant Dashboard"}
              </div>
              <CreateNew
                className={classNames("__wab_instance", sty.createNew__bSHr)}
              />

              <Icons8Settings1Icon
                className={classNames(projectcss.all, sty.svg__wLd3B)}
                role={"img"}
              />

              <DividerLineVerticalIcon
                className={classNames(projectcss.all, sty.svg__rQxwo)}
                role={"img"}
              />

              <div
                data-plasmic-name={"name4"}
                data-plasmic-override={overrides.name4}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.name4
                )}
              >
                {"Jones Ferdinand"}
              </div>
              <GroupIcon
                className={classNames(projectcss.all, sty.svg__nRGna)}
                role={"img"}
              />
            </Stack__>
          ) : null}
        </Stack__>
      ) : null}
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "title6",
    "createNewStack",
    "settingsButton",
    "name",
    "profileStackInstance",
    "title7",
    "name2",
    "title8",
    "name3",
    "title9",
    "name4"
  ],

  title6: ["title6"],
  createNewStack: ["createNewStack"],
  settingsButton: ["settingsButton"],
  name: ["name"],
  profileStackInstance: ["profileStackInstance"],
  title7: ["title7"],
  name2: ["name2"],
  title8: ["title8"],
  name3: ["name3"],
  title9: ["title9"],
  name4: ["name4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTopBar__ArgProps,
          internalVariantPropNames: PlasmicTopBar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTopBar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTopBar";
  } else {
    func.displayName = `PlasmicTopBar.${nodeName}`;
  }
  return func;
}

export const PlasmicTopBar = Object.assign(
  // Top-level PlasmicTopBar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title6: makeNodeComponent("title6"),
    createNewStack: makeNodeComponent("createNewStack"),
    settingsButton: makeNodeComponent("settingsButton"),
    _name: makeNodeComponent("name"),
    profileStackInstance: makeNodeComponent("profileStackInstance"),
    title7: makeNodeComponent("title7"),
    name2: makeNodeComponent("name2"),
    title8: makeNodeComponent("title8"),
    name3: makeNodeComponent("name3"),
    title9: makeNodeComponent("title9"),
    name4: makeNodeComponent("name4"),
    // Metadata about props expected for PlasmicTopBar
    internalVariantProps: PlasmicTopBar__VariantProps,
    internalArgProps: PlasmicTopBar__ArgProps
  }
);

export default PlasmicTopBar;
/* prettier-ignore-end */
